module.exports = __webpack_public_path__ + "static/media/bot-wave.4ac84ed8.svg";